<div class="content">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2 class="mb-1">Employee</h2>
      <nav>
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a routerLink="dashboard" href="javascript:void(0);"
              ><i class="ti ti-smart-home"></i
            ></a>
          </li>
          <!-- <li class="breadcrumb-item">
              Employee
            </li> -->
          <li class="breadcrumb-item active" aria-current="page">Employee List</li>
        </ol>
      </nav>
    </div>
    <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
      <div class="me-2 mb-2 d-none">
        <div class="dropdown">
          <a
            href="javascript:void(0);"
            class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
            data-bs-toggle="dropdown"
          >
            <i class="ti ti-file-export me-1"></i>Export
          </a>
          <ul class="dropdown-menu dropdown-menu-end p-3">
            <li>
              <a href="javascript:void(0);" class="dropdown-item rounded-1"
                ><i class="ti ti-file-type-pdf me-1"></i>Export as PDF</a
              >
            </li>
            <li>
              <a href="javascript:void(0);" class="dropdown-item rounded-1"
                ><i class="ti ti-file-type-xls me-1"></i>Export as Excel
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="mb-2">
        <button
          type="button"
          *appHasPermission="{ employees: ['add'] }"
          (click)="openBusinessModal(addBusinessModals)"
          class="btn btn-primary d-flex align-items-center"
        >
          <i class="ti ti-circle-plus me-2"></i>Add Employee
        </button>
      </div>
      <div class="head-icons ms-2 d-none">
        <a
          href="javascript:void(0);"
          class=""
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          data-bs-original-title="Collapse"
          id="collapse-header"
        >
          <i class="ti ti-chevrons-up"></i>
        </a>
      </div>
    </div>
  </div>
  <!-- /Breadcrumb -->

  <div class="filter-filelds d-none" id="filter_inputs">
    <div class="row filter-row">
      <div class="col-xl-2">
        <div class="input-block mb-3 form-focus">
          <input type="text" class="form-control floating" />
          <label class="focus-label" for="officename">Office Name</label>
        </div>
      </div>
      <div class="col-xl-2">
        <div class="input-block mb-3 form-focus">
          <input type="text" class="form-control floating" />
          <label class="focus-label" for="email">Email</label>
        </div>
      </div>
      <div class="col-xl-2">
        <div class="input-block mb-3 form-focus">
          <input type="text" class="form-control floating" />
          <label class="focus-label" for="mobile">Mobile Number</label>
        </div>
      </div>
      <div class="col-xl-2">
        <div class="input-block mb-3 form-focus focused">
          <input type="text" class="form-control date-range bookingrange" />
          <label class="focus-label" for="fromto">From - To Date</label>
        </div>
      </div>
      <div class="col-xl-2">
        <div class="input-block mb-3 form-focus select-focus">
          <select class="select floating" data-extension-safe>
            <option>--Select--</option>
            <option>Germany</option>
            <option>USA</option>
            <option>Canada</option>
            <option>India</option>
            <option>China</option>
          </select>
          <label class="focus-label" for="Location">Location</label>
        </div>
      </div>
      <div class="col-xl-2">
        <a href="#" class="btn btn-success w-100"> Search </a>
      </div>
    </div>
  </div>
  <hr />

  <div class="filter-section d-none">
    <ul>
      <li class="d-none">
        <div class="view-icons">
          <a href="companies.html" class="list-view btn btn-link active"
            ><i class="las la-list"></i
          ></a>
          <a href="companies-grid.html" class="grid-view btn btn-link"><i class="las la-th"></i></a>
        </div>
      </li>
      <li>
        <div class="form-sort" style="width: 200px !important">
          <i class="las la-sort-alpha-up-alt"></i>
          <select class="form-select" style="padding-left: 1.75rem !important" data-extension-safe>
            <!-- <option selected disabled>Sort By Alphabet</option> -->
            <option value="asc">Ascending</option>
            <option value="desc">Descending</option>
            <!-- <option>Recently Viewed</option>
              <option>Recently Added</option> -->
          </select>
        </div>
      </li>
      <li class="d-none">
        <div class="form-sorts dropdown">
          <a href="javascript:void(0);" class="dropdown-toggle" id="table-filter"
            ><i class="las la-filter me-2"></i>Filter</a
          >
          <div class="filter-dropdown-menu">
            <div class="filter-set-view">
              <div class="filter-set-head">
                <h4>Filter</h4>
              </div>
              <div class="accordion" id="accordionExample">
                <div class="filter-set-content">
                  <div class="filter-set-content-head">
                    <a
                      href="#"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                      >Rating<i class="las la-angle-right"></i
                    ></a>
                  </div>
                  <div
                    class="filter-set-contents accordion-collapse collapse show"
                    id="collapseOne"
                    data-bs-parent="#accordionExample"
                  >
                    <ul>
                      <li>
                        <div class="filter-checks">
                          <label class="checkboxs">
                            <input type="checkbox" checked />
                            <span class="checkmarks"></span>
                          </label>
                        </div>
                        <div class="rating">
                          <i class="fa fa-star filled"></i>
                          <i class="fa fa-star filled"></i>
                          <i class="fa fa-star filled"></i>
                          <i class="fa fa-star filled"></i>
                          <i class="fa fa-star filled"></i>
                          <span>5.0</span>
                        </div>
                      </li>
                      <li>
                        <div class="filter-checks">
                          <label class="checkboxs">
                            <input type="checkbox" />
                            <span class="checkmarks"></span>
                          </label>
                        </div>
                        <div class="rating">
                          <i class="fa fa-star filled"></i>
                          <i class="fa fa-star filled"></i>
                          <i class="fa fa-star filled"></i>
                          <i class="fa fa-star filled"></i>
                          <i class="fa fa-star"></i>
                          <span>4.0</span>
                        </div>
                      </li>
                      <li>
                        <div class="filter-checks">
                          <label class="checkboxs">
                            <input type="checkbox" />
                            <span class="checkmarks"></span>
                          </label>
                        </div>
                        <div class="rating">
                          <i class="fa fa-star filled"></i>
                          <i class="fa fa-star filled"></i>
                          <i class="fa fa-star filled"></i>
                          <i class="fa fa-star"></i>
                          <i class="fa fa-star"></i>
                          <span>3.0</span>
                        </div>
                      </li>
                      <li>
                        <div class="filter-checks">
                          <label class="checkboxs">
                            <input type="checkbox" />
                            <span class="checkmarks"></span>
                          </label>
                        </div>
                        <div class="rating">
                          <i class="fa fa-star filled"></i>
                          <i class="fa fa-star filled"></i>
                          <i class="fa fa-star"></i>
                          <i class="fa fa-star"></i>
                          <i class="fa fa-star"></i>
                          <span>2.0</span>
                        </div>
                      </li>
                      <li>
                        <div class="filter-checks">
                          <label class="checkboxs">
                            <input type="checkbox" />
                            <span class="checkmarks"></span>
                          </label>
                        </div>
                        <div class="rating">
                          <i class="fa fa-star filled"></i>
                          <i class="fa fa-star"></i>
                          <i class="fa fa-star"></i>
                          <i class="fa fa-star"></i>
                          <i class="fa fa-star"></i>
                          <span>1.0</span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="filter-set-content">
                  <div class="filter-set-content-head">
                    <a
                      href="#"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseTwo"
                      aria-expanded="false"
                      aria-controls="collapseTwo"
                      >Owner<i class="las la-angle-right"></i
                    ></a>
                  </div>
                  <div
                    class="filter-set-contents accordion-collapse collapse"
                    id="collapseTwo"
                    data-bs-parent="#accordionExample"
                  >
                    <ul>
                      <li>
                        <div class="filter-checks">
                          <label class="checkboxs">
                            <input type="checkbox" checked />
                            <span class="checkmarks"></span>
                          </label>
                        </div>
                        <div class="collapse-inside-text">
                          <h5>Hendry</h5>
                        </div>
                      </li>
                      <li>
                        <div class="filter-checks">
                          <label class="checkboxs">
                            <input type="checkbox" />
                            <span class="checkmarks"></span>
                          </label>
                        </div>
                        <div class="collapse-inside-text">
                          <h5>Guillory</h5>
                        </div>
                      </li>
                      <li>
                        <div class="filter-checks">
                          <label class="checkboxs">
                            <input type="checkbox" />
                            <span class="checkmarks"></span>
                          </label>
                        </div>
                        <div class="collapse-inside-text">
                          <h5>Jami</h5>
                        </div>
                      </li>
                      <li>
                        <div class="filter-checks">
                          <label class="checkboxs">
                            <input type="checkbox" />
                            <span class="checkmarks"></span>
                          </label>
                        </div>
                        <div class="collapse-inside-text">
                          <h5>Theresa</h5>
                        </div>
                      </li>
                      <li>
                        <div class="filter-checks">
                          <label class="checkboxs">
                            <input type="checkbox" />
                            <span class="checkmarks"></span>
                          </label>
                        </div>
                        <div class="collapse-inside-text">
                          <h5>Espinosa</h5>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="filter-set-content">
                  <div class="filter-set-content-head">
                    <a
                      href="#"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseThree"
                      aria-expanded="false"
                      aria-controls="collapseThree"
                      >Tags<i class="las la-angle-right"></i
                    ></a>
                  </div>
                  <div
                    class="filter-set-contents accordion-collapse collapse"
                    id="collapseThree"
                    data-bs-parent="#accordionExample"
                  >
                    <ul>
                      <li>
                        <div class="filter-checks">
                          <label class="checkboxs">
                            <input type="checkbox" checked />
                            <span class="checkmarks"></span>
                          </label>
                        </div>
                        <div class="collapse-inside-text">
                          <h5>Promotion</h5>
                        </div>
                      </li>
                      <li>
                        <div class="filter-checks">
                          <label class="checkboxs">
                            <input type="checkbox" />
                            <span class="checkmarks"></span>
                          </label>
                        </div>
                        <div class="collapse-inside-text">
                          <h5>Rated</h5>
                        </div>
                      </li>
                      <li>
                        <div class="filter-checks">
                          <label class="checkboxs">
                            <input type="checkbox" />
                            <span class="checkmarks"></span>
                          </label>
                        </div>
                        <div class="collapse-inside-text">
                          <h5>Rejected</h5>
                        </div>
                      </li>
                      <li>
                        <div class="filter-checks">
                          <label class="checkboxs">
                            <input type="checkbox" />
                            <span class="checkmarks"></span>
                          </label>
                        </div>
                        <div class="collapse-inside-text">
                          <h5>Collab</h5>
                        </div>
                      </li>
                      <li>
                        <div class="filter-checks">
                          <label class="checkboxs">
                            <input type="checkbox" />
                            <span class="checkmarks"></span>
                          </label>
                        </div>
                        <div class="collapse-inside-text">
                          <h5>Calls</h5>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="filter-reset-btns">
                <a href="#" class="btn btn-light">Reset</a>
                <a href="#" class="btn btn-primary">Filter</a>
              </div>
            </div>
          </div>
        </div>
      </li>
      <li>
        <div class="search-set">
          <div class="search-input">
            <a href="#" class="btn btn-searchset"><i class="las la-search"></i></a>
            <div class="dataTables_filter">
              <label>
                <input type="search" class="form-control form-control-sm" placeholder="Search"
              /></label>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>

  <div class="row">
    <!-- Total Plans -->
    <div class="col-lg-3 col-md-6 d-flex">
      <div class="card flex-fill">
        <div class="card-body d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center overflow-hidden">
            <div>
              <span class="avatar avatar-lg bg-dark rounded-circle"
                ><i class="ti ti-users"></i
              ></span>
            </div>
            <div class="ms-2 overflow-hidden">
              <p class="fs-12 fw-medium mb-1 text-truncate">Total Employee</p>
              <h4>{{ totalCount }}</h4>
            </div>
          </div>
          <div>
            <span class="badge badge-soft-purple badge-sm fw-normal">
              <i class="ti ti-arrow-wave-right-down"></i>
              0
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- /Total Plans -->

    <!-- Total Plans -->
    <div class="col-lg-3 col-md-6 d-flex">
      <div class="card flex-fill">
        <div class="card-body d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center overflow-hidden">
            <div>
              <span class="avatar avatar-lg bg-success rounded-circle"
                ><i class="ti ti-user-share"></i
              ></span>
            </div>
            <div class="ms-2 overflow-hidden">
              <p class="fs-12 fw-medium mb-1 text-truncate">Active</p>
              <h4>{{ activeCount }}</h4>
            </div>
          </div>
          <div>
            <span class="badge badge-soft-primary badge-sm fw-normal">
              <i class="ti ti-arrow-wave-right-down"></i>
              0
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- /Total Plans -->

    <!-- Inactive Plans -->
    <div class="col-lg-3 col-md-6 d-flex">
      <div class="card flex-fill">
        <div class="card-body d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center overflow-hidden">
            <div>
              <span class="avatar avatar-lg bg-danger rounded-circle"
                ><i class="ti ti-user-pause"></i
              ></span>
            </div>
            <div class="ms-2 overflow-hidden">
              <p class="fs-12 fw-medium mb-1 text-truncate">InActive</p>
              <h4>{{ inactiveCount }}</h4>
            </div>
          </div>
          <div>
            <span class="badge badge-soft-dark badge-sm fw-normal">
              <i class="ti ti-arrow-wave-right-down"></i>
              0
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- /Inactive Companies -->

    <!-- No of Plans  -->
    <div class="col-lg-3 col-md-6 d-flex">
      <div class="card flex-fill">
        <div class="card-body d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center overflow-hidden">
            <div>
              <span class="avatar avatar-lg bg-info rounded-circle"
                ><i class="ti ti-user-plus"></i
              ></span>
            </div>
            <div class="ms-2 overflow-hidden">
              <p class="fs-12 fw-medium mb-1 text-truncate">New Joiners</p>
              <h4>{{ newJoineeCount }}</h4>
            </div>
          </div>
          <div>
            <span class="badge badge-soft-secondary badge-sm fw-normal">
              <i class="ti ti-arrow-wave-right-down"></i>
              0
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- /No of Plans -->
  </div>

  <div class="card">
    <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
      <h5>Employee List</h5>
      <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
        <div class="me-3" *ngIf="employees$ | async as employees">
          <select
            data-extension-safe
            class="form-select form-select-sm col-md-1"
            id="entries"
            [(ngModel)]="pageLimit"
            (change)="onPageLimitChange()"
          >
            <!-- <option selected disabled>Show Entries Per Page</option> -->
            <option *ngFor="let limit of [10, 20, 50, 100]" [value]="limit">{{ limit }}</option>
          </select>
        </div>

        <ng-select
          class="me-3"
          [items]="businesses$ | async"
          bindValue="id"
          placeholder="Select Business Entity"
          [(ngModel)]="businessId"
          (change)="loadEmployees()"
          [searchable]="true"
          [clearable]="true"
          [searchFn]="customSearchFn"
          style="width: 200px"
        >
          <ng-template ng-label-tmp let-item="item">
            {{ item.businessName | capitalize }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            {{ item.businessName | capitalize }}
          </ng-template>
        </ng-select>

        <div class="dropdown me-3">
          <!-- <select
            class="form-select"
            #statusSelect
            [(ngModel)]="status"
            (change)="loadEmployees(); setCurrentPage()"
          > -->
          <select
            class="form-select"
            #statusSelect
            [(ngModel)]="status"
            (change)="onStatusChange()"
          >
            <!-- <option value="" selected>Select Status</option>
            <option value="false">Active</option>
            <option value="true">Inactive</option> -->
            <option [ngValue]="null">Select Status</option>
            <option [ngValue]="false">Active</option>
            <option [ngValue]="true">Inactive</option>
          </select>
        </div>

        <div class="form-sort me-3 d-none">
          <select class="form-select" data-extension-safe>
            <!-- <option selected disabled>Sort By Alphabet</option> -->
            <option value="asc">Ascending</option>
            <option value="desc">Descending</option>
            <!-- <option>Recently Viewed</option>
              <option>Recently Added</option> -->
          </select>
        </div>

        <div class="form-sort search-box">
          <label>
            <input
              type="search"
              class="form-control"
              placeholder="Search"
              [(ngModel)]="search"
              (input)="loadEmployees(); setCurrentPage()"
          /></label>
        </div>
      </div>
    </div>
    <div class="card-body p-0">
      <div class="custom-datatable-filter table-responsive">
        <!-- <ng-container *ngIf="employees$ | async as employees">
          <ng-container *ngIf="businesses$ | async as business">
            <ng-container *ngIf="employees.length === 0">
              <div
                class="alert bg-danger-transparent alert-dismissible fade show mb-4"
                *ngIf="officeCount === 0 || departmentCount === 0 || designationCount === 0"
              >
                To create a new employee you should first create
                <span *ngIf="officeCount === 0">Office</span>,
                <span *ngIf="departmentCount === 0">Department</span>,
                <span *ngIf="designationCount === 0">Designation</span>
                <button
                  type="button"
                  class="btn-close fs-14"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                >
                  <i class="ti ti-x"></i>
                </button>
              </div>
            </ng-container>
          </ng-container> -->
        <!-- employees render immediately -->
        <ng-container *ngIf="employees$ | async as employees">
          <!-- render employee-related UI first -->
          <!-- <ng-container *ngIf="employees.length === 0">
            <div
              class="alert bg-danger-transparent alert-dismissible fade show mb-4"
              *ngIf="officeCount === 0 || departmentCount === 0 || designationCount === 0"
            >
              To create a new employee you should first create
              <span *ngIf="officeCount === 0">Office</span>,
              <span *ngIf="departmentCount === 0">Department</span>,
              <span *ngIf="designationCount === 0">Designation</span>
              <button
                type="button"
                class="btn-close fs-14"
                data-bs-dismiss="alert"
                aria-label="Close"
              >
                <i class="ti ti-x"></i>
              </button>
            </div>
          </ng-container> -->

          <table class="table datatable" *ngIf="employees.length > 0; else noRecords">
            <thead class="thead-light">
              <tr>
                <th>Name</th>
                <th>Contact</th>
                <!-- <th>Mobile</th> -->
                <th>Office</th>
                <!-- <th>Business Entity</th> -->
                <!-- <th>Owner</th> -->
                <!-- <th>Role</th> -->
                <!-- <th>Status</th> -->
                <!-- <th>Dates</th> -->
                <th>System Information</th>
                <th class="text-end">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let employee of employees$ | async">
                <td>
                  <div class="d-flex align-items-center">
                    <a
                      [routerLink]="['/hrm/employee', employee.id]"
                      class="employee-avatar"
                      data-bs-toggle="modal"
                      data-bs-target="#view_details"
                    >
                      <!-- <img
                        [src]="employee.picture ? businessImages[employee.picture] : defaultImg"
                        class="img-fluid rounded-circle"
                        alt="img"
                      /> -->
                      <!-- <ng-container
                        *ngIf="employee.picture && businessImages[employee.picture]; else initials"
                      >
                        <img
                          [src]="businessImages[employee.picture]"
                          (error)="onImageError(employee)"
                          class="img-fluid rounded-circle"
                          alt="img"
                          style="width: 100%; height: 100%; object-fit: cover"
                        />
                      </ng-container>

                      <ng-template #initials>
                        <span
                          class="rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white fw-bold"
                          style="width: 100%; height: 100%"
                          >{{ getInitials(employee.firstName, employee.lastName) }}</span
                        >
                      </ng-template> -->
                      <!-- <ng-container
                        *ngIf="employee.picture && businessImages[employee.picture]; else initials"
                      > -->
                      <ng-container *ngIf="employee.picture; else initials">
                        <span
                          class="avatar-wrapper"
                          [ngClass]="employee.disabled ? 'offline' : 'online'"
                        >
                          <img
                            [src]="apiEndpoint + '/uploads/' + employee.picture"
                            (error)="onImageError(employee)"
                            alt="Img"
                            loading="lazy"
                        /></span>
                      </ng-container>
                      <ng-template #initials>
                        <span
                          class="avatar-wrapper avatar-initials"
                          [ngClass]="employee.disabled ? 'offline' : 'online'"
                        >
                          {{ getInitials(employee.firstName, employee.lastName) }}
                        </span>
                      </ng-template>

                      <!-- ✅ Status icon -->
                      <!-- <span
                        class="position-absolute bottom-0 end-0 me-1 mb-1 rounded-circle p-1"
                        [ngClass]="employee.disabled ? 'bg-danger' : 'bg-success'"
                        style="
                          width: 5px;
                          height: 5px;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                        "
                      > -->
                      <!-- <i
                          class="ti"
                          [ngClass]="employee.disabled ? 'ti-x' : 'ti-check'"
                          style="font-size: 10px; color: white"
                        ></i> -->
                      <!-- </span> -->
                    </a>
                    <div class="ms-2">
                      <p class="text-dark mb-0">
                        <a
                          [routerLink]="['/hrm/employee', employee.id]"
                          data-bs-toggle="modal"
                          data-bs-target="#view_details"
                          >{{ employee.firstName | capitalize }}
                          {{ employee.lastName | capitalize }}</a
                        >
                      </p>
                      <span class="fs-12" *ngIf="employee.empId">{{ employee.empId }}</span>
                      <!-- <span class="fs-12">{{ employee.role?.name | capitalize }}</span> -->
                      <!-- <span class="fs-12">{{
                        employee && employee.userRoles.length > 0
                          ? (employee.userRoles[0]?.role?.name | capitalize)
                          : ''
                      }}</span> -->
                      <span class="fs-12"
                        ><br />{{ employee.designation?.designationName | capitalize }}</span
                      >
                    </div>
                  </div>
                </td>
                <td>
                  Email:
                  <a
                    href="mailto:{{ employee.email }}"
                    class="__cf_email__"
                    data-cfemail="4a3825282f383e3925240a2f322b273a262f64292527"
                    >{{ employee.email }}</a
                  ><br />
                  Mobile: {{ employee.mobile }}
                </td>
                <!-- <td>{{ employee.mobile }}</td> -->
                <td>
                  Office:
                  {{
                    employee.office?.officeName ? (employee.office?.officeName | capitalize) : 'N/A'
                  }}
                  <br />
                  Business:
                  {{
                    employee.business?.businessName
                      ? (employee.business.businessName | capitalize)
                      : 'N/A'
                  }}
                </td>

                <!-- <td>
                  Created By:
                  {{
                    employee.createdByUser
                      ? employee.createdByUser.firstName + ' ' + employee.createdByUser.lastName
                      : 'Automated User'
                  }}
                  <br />
                  Created At:
                  {{ employee.createdAt | date: 'medium' }}
                  <br />
                  Last Modified By:
                  {{
                    employee.lastModifiedByUser
                      ? employee.lastModifiedByUser.firstName +
                        ' ' +
                        employee.lastModifiedByUser.lastName
                      : 'N/A'
                  }}
                  <br />
                  Last Modified At:
                  {{ employee.lastModifiedOn ? (employee.lastModifiedOn | date: 'medium') : 'N/A' }}
                </td> -->

                <td>
                  Created By:
                  {{
                    employee.createdByUser
                      ? employee.createdByUser.firstName + ' ' + employee.createdByUser.lastName
                      : 'Automated User'
                  }},
                  {{ employee.createdAt | date: 'medium' }}
                  <br />
                  Last Modified By:
                  {{
                    employee.lastModifiedByUser
                      ? employee.lastModifiedByUser.firstName +
                        ' ' +
                        employee.lastModifiedByUser.lastName
                      : 'N/A'
                  }},
                  {{ employee.lastModifiedOn ? (employee.lastModifiedOn | date: 'medium') : 'N/A' }}
                </td>

                <!-- <td>{{ employee.business?.businessName | capitalize }}</td> -->
                <!-- <td>
                  {{ employee.business?.user?.firstName | capitalize }}
                  {{ employee.business?.user?.lastName | capitalize }}
                </td> -->
                <!-- <td>
                  {{ employee.role | capitalize }}
                </td> -->
                <!-- <td>
                  <span
                    *ngIf="!employee.disabled"
                    class="badge badge-success d-inline-flex align-items-center badge-xs"
                  >
                   Active
                  </span>
                  <span
                    *ngIf="employee.disabled"
                    class="badge badge-danger d-inline-flex align-items-center badge-xs"
                  >
                   Inactive
                  </span>
                </td> -->
                <td class="text-end">
                  <div class="action-icon d-inline-flex">
                    <a
                      [routerLink]="['/hrm/employee', employee.id]"
                      class="me-2"
                      *appHasPermission="{ employees: ['view'] }"
                      ><i class="ti ti-eye"></i
                    ></a>
                    <span *appHasPermission="{ employees: ['status'] }">
                      <a
                        href="javascript:void(0);"
                        class="me-2"
                        (click)="openModal(false, employee.id.toString())"
                        *ngIf="employee.disabled"
                      >
                        <i class="ti ti-lock"></i>
                      </a>
                      <a
                        href="javascript:void(0);"
                        class="me-2"
                        (click)="openModal(true, employee.id.toString())"
                        *ngIf="!employee.disabled"
                      >
                        <i class="ti ti-lock-open-2"></i>
                      </a>
                    </span>

                    <!-- <a
                      href="javascript:void(0);"
                      *appHasPermission="{ employees: ['delete'] }"
                      (click)="openDeleteModal(employee.id.toString())"
                      ><i class="ti ti-trash"></i
                    ></a>-->
                    <a
                      href="javascript:void(0);"
                      *ngIf="isAdmin() && user?.id !== employee.id"
                      (click)="switchToUser(employee.id)"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Switch to User"
                    >
                      <i class="ti ti-user-share"></i>
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </ng-container>
        <ng-template #noRecords>
          <div class="text-center">Record not available</div>
        </ng-template>
      </div>
    </div>
    <!-- pagination -->
    <ng-container *ngIf="employees$ | async as employees">
      <div
        class="d-flex align-items-center justify-content-between ms-2"
        *ngIf="employees.length > 0"
      >
        <div>
          Showing {{ (currentPage - 1) * pageLimit + 1 }} to {{ pageLastRecord }} of
          <!-- {{ totalCount }} entries -->
          {{ status === true ? inactiveCount : status === false ? activeCount : totalCount }}
          entries
          <!-- Showing
          {{ (currentPage - 1) * pageLimit + 1 }}
          to
          {{ Math.min(currentPage * pageLimit, totalCount) }}
          of
          {{ totalCount }} entries -->
          <!-- Showing {{ (currentPage - 1) * pageLimit + 1 }} to {{ currentPage * pageLimit }} of
          {{ totalCount }} entries -->
        </div>
        <div class="has-text-centered mt-3">
          <app-pagination
            [currentPage]="currentPage"
            [pageSize]="pageLimit"
            [totalRows]="
              status === true ? inactiveCount : status === false ? activeCount : totalCount
            "
            (pageChange)="onPageChange($event)"
          ></app-pagination>
        </div>
      </div>
    </ng-container>
    <!-- pagination end -->
  </div>
</div>

<app-block-unblock
  *ngIf="showModal"
  [isBlocking]="isBlocking"
  [recordId]="blockEmployeeId"
></app-block-unblock>

<app-delete *ngIf="showDeleteModal" [recordId]="blockEmployeeId"></app-delete>

<ng-template #addBusinessModals let-modal>
  <!-- <div class="modal custom-modal fade custom-modal-two modal-padding" id="add_company" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content"> -->
  <div class="modal-header header-border justify-content-between m-2">
    <h5 class="modal-title">Add New Employee</h5>
    <button
      type="button"
      class="btn-close custom-btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="onClose()"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <div class="modal-body m-2">
    <div class="contact-grids-tab">
      <ul class="nav nav-underline" id="myTab" role="tablist">
        <li
          class="nav-item"
          role="presentation"
          [class.active]="currentStep === 1"
          (click)="stepChange(1)"
        >
          <span class="nav-link" [class.active]="currentStep === 1">Basic Information</span>
        </li>
        <!-- <li class="nav-item" role="presentation" [class.active]="currentStep === 2" (click)="stepChange(2)" >
          <span class="nav-link" [class.active]="currentStep === 2"  >Address</span>
        </li> -->
        <!-- <li class="nav-item" role="presentation" [class.active]="currentStep === 2" (click)="stepChange(2)"  >
          <span class="nav-link" [class.active]="currentStep === 2"  >Social Profiles</span>
        </li> -->
        <!-- <li
          class="nav-item"
          role="presentation"
          [class.active]="currentStep === 2"
          (click)="stepChange(2)"
        >
          <span class="nav-link" [class.active]="currentStep === 2">Roles & Permissions</span>
        </li> -->
      </ul>
    </div>

    <div class="tab-content">
      <form [formGroup]="form" autocomplete="off" enctype="multipart/form-data" autocomplete="off">
        <!-- Step 1 (Basic Info) -->
        <fieldset *ngIf="currentStep === 1" formGroupName="companyInfoForm" id="first-field">
          <div class="col-md-12">
            <div
              class="d-flex align-items-center flex-wrap row-gap-3 bg-light w-100 rounded p-3 mb-4"
            >
              <div
                class="d-flex align-items-center justify-content-center avatar avatar-xxl rounded-circle border border-dashed me-2 flex-shrink-0 text-dark frames"
              >
                <i class="ti ti-photo text-gray-2 fs-16" *ngIf="!imageURL"></i>
                <!-- <span
                  ><img
                    [src]="imageURL"
                    alt="Img"
                    class="img-fluid rounded-circle"
                    *ngIf="imageURL"
                /></span> -->
                <img
                  [src]="imageURL"
                  alt="Img"
                  *ngIf="imageURL"
                  class="rounded-circle"
                  style="width: 100%; height: 100%; object-fit: cover"
                />
              </div>
              <div class="profile-upload">
                <div class="mb-2">
                  <h6 class="mb-1">Upload Profile Image</h6>
                  <!-- <p class="fs-12">Image should be below 4 mb</p> -->
                </div>
                <div class="profile-uploader d-flex align-items-center">
                  <div class="drag-upload-btn btn btn-sm btn-primary me-2">
                    Upload
                    <!-- <input type="file" class="form-control image-sign" formControlName="picture"
                    (change)="showPreview($event, 'imageURL')"> -->
                    <input
                      type="file"
                      class="form-control image-sign"
                      accept="image/jpeg, image/png, image/gif, image/svg+xml, image/webp"
                      (change)="onFileChange($event, 'imageURL')"
                    />
                  </div>
                  <!-- <a href="javascript:void(0);" class="btn btn-light btn-sm">Cancel</a> -->
                </div>
              </div>
            </div>
          </div>
          <div class="contact-input-set">
            <div class="row">
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label" for="firstName"
                    >First Name <span class="text-danger"> *</span></label
                  >
                  <input formControlName="firstName" class="form-control" appTrimInput />
                  <div
                    *ngIf="
                      form.get('companyInfoForm')?.get('firstName')?.invalid &&
                      form.get('companyInfoForm')?.get('firstName')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('companyInfoForm.firstName') }}
                    </span>
                  </div>
                  <!-- Other fields for Basic Info here -->
                </div>
              </div>

              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label" for="lastName"
                    >Last Name <span class="text-danger"> *</span></label
                  >
                  <input formControlName="lastName" class="form-control" appTrimInput />
                  <div
                    *ngIf="
                      form.get('companyInfoForm')?.get('lastName')?.invalid &&
                      form.get('companyInfoForm')?.get('lastName')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('companyInfoForm.lastName') }}
                    </span>
                  </div>
                  <!-- Other fields for Basic Info here -->
                </div>
              </div>
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label" for="email"
                    >Work Email <span class="text-danger"> *</span>
                    <i
                      class="ti ti-help text-info ms-2"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Format: dave@gmail.com"
                    ></i>
                  </label>
                  <input
                    formControlName="email"
                    class="form-control"
                    type="email"
                    autocomplete="off"
                    appStrictEmail
                    appTrimInput
                  />
                  <div
                    *ngIf="
                      form.get('companyInfoForm')?.get('email')?.invalid &&
                      form.get('companyInfoForm')?.get('email')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('companyInfoForm.email') }}
                    </span>
                  </div>
                  <!-- Other fields for Basic Info here -->
                </div>
              </div>
              <!-- <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label" for="personalEmail">Alternate Email </label>
                  <input
                    formControlName="personalEmail"
                    class="form-control"
                    type="email"
                    autocomplete="off"
                  />
                  <div
                    *ngIf="
                      form.get('companyInfoForm')?.get('personalEmail')?.invalid &&
                      form.get('companyInfoForm')?.get('personalEmail')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('companyInfoForm.personalEmail') }}
                    </span>
                  </div>
                </div>
              </div> -->

              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label" for="mobile"
                    >Mobile Number<span class="text-danger"> *</span>
                    <i
                      class="ti ti-help text-info ms-2"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Format: +91 9876543210"
                    ></i>
                  </label>
                  <input class="form-control" type="text" formControlName="mobile" appTrimInput />
                  <div
                    *ngIf="
                      form.get('companyInfoForm')?.get('mobile')?.invalid &&
                      form.get('companyInfoForm')?.get('mobile')?.touched
                    "
                  >
                    <span class="text-danger">
                      <ng-container
                        *ngIf="
                          form.get('companyInfoForm')?.get('mobile')?.hasError('required') &&
                          form.get('companyInfoForm')?.get('mobile')?.value === ''
                        "
                      >
                        Mobile number is required.
                      </ng-container>
                      <ng-container
                        *ngIf="
                          form
                            .get('companyInfoForm')
                            ?.get('mobile')
                            ?.hasError('invalidMobileNumber') &&
                          form.get('companyInfoForm')?.get('mobile')?.value !== ''
                        "
                      >
                        Invalid mobile number format. Please use +XX XXXXXXXXXX.
                      </ng-container>
                    </span>
                  </div>
                </div>
              </div>
              <!-- <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label" for="personalMobile">Alternate Mobile Number</label>
                  <input class="form-control" type="text" formControlName="personalMobile" />
                  <div
                    *ngIf="
                      form.get('companyInfoForm')?.get('personalMobile')?.invalid &&
                      form.get('companyInfoForm')?.get('personalMobile')?.touched
                    "
                  >
                    <span class="text-danger">
                      <ng-container
                        *ngIf="
                          form
                            .get('companyInfoForm')
                            ?.get('personalMobile')
                            ?.hasError('required') &&
                          form.get('companyInfoForm')?.get('personalMobile')?.value === ''
                        "
                      >
                        Mobile number is required.
                      </ng-container>
                      <ng-container
                        *ngIf="
                          form
                            .get('companyInfoForm')
                            ?.get('personalPhone')
                            ?.hasError('invalidPhoneNumber') &&
                          form.get('companyInfoForm')?.get('personalPhone')?.value !== ''
                        "
                      >
                        Invalid mobile number format. Please use +XX XXXXXXXXXX.
                      </ng-container>
                    </span>
                  </div>
                </div>
              </div> -->

              <!-- <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label" for="birthdate"
                    >Date of Birth <span class="text-danger"> *</span></label
                  >
                  <input
                    class="form-control"
                    type="date"
                    formControlName="birthdate"
                    [max]="maxDate"
                  />
                  <div
                    *ngIf="
                      form.get('companyInfoForm')?.get('birthdate')?.invalid &&
                      form.get('companyInfoForm')?.get('birthdate')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('companyInfoForm.birthdate') }}
                    </span>
                  </div>
                  <ng-container *ngIf="form.get('basicInfoForm.birthdate')?.hasError('ageInvalid')">
                    <span class="text-danger">You must be at least 18 years old.</span>
                  </ng-container>
                </div>
              </div> -->

              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label" for="businessId"
                    >Business Entity <span class="text-danger">*</span></label
                  >
                  <!-- <select
                    data-extension-safe
                    class="form-select"
                    formControlName="businessId"
                    [(ngModel)]="selectedBusinessId"
                    (change)="onBusinessChange(selectedBusinessId)"
                  >
                    <option selected value="">Select Business Entity</option>
                    <option *ngFor="let business of businesses$ | async" [value]="business.id">
                      {{ business.businessName | capitalize }}
                    </option>
                  </select> -->
                  <ng-select
                    class="me-3 w-100"
                    [items]="businesses$ | async"
                    bindValue="id"
                    placeholder="Select Business Entity"
                    [searchable]="true"
                    [clearable]="true"
                    [searchFn]="customSearchFn"
                    style="width: 200px"
                    formControlName="businessId"
                    [(ngModel)]="selectedBusinessId"
                    (change)="onBusinessChange(selectedBusinessId)"
                  >
                    <ng-template ng-label-tmp let-item="item">
                      {{ item.businessName | capitalize }}
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item">
                      {{ item.businessName | capitalize }}
                    </ng-template>
                  </ng-select>
                  <div
                    *ngIf="
                      form.get('companyInfoForm')?.get('businessId')?.invalid &&
                      form.get('companyInfoForm')?.get('businessId')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('companyInfoForm.businessId') }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label" for="joiningDate"
                    >Date of Joining <span class="text-danger"> *</span></label
                  >
                  <input
                    class="form-control"
                    type="date"
                    formControlName="joiningDate"
                    appTrimInput
                    [max]="todayplussixmonths | date: 'yyyy-MM-dd'"
                    [min]="(selectedBusiness$ | async)?.incorporationDate | date: 'yyyy-MM-dd'"
                  />
                  <div
                    *ngIf="
                      form.get('companyInfoForm')?.get('joiningDate')?.invalid &&
                      form.get('companyInfoForm')?.get('joiningDate')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('companyInfoForm.joiningDate') }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label" for="officeId"
                    >Office <span class="text-danger">*</span></label
                  >
                  <select class="form-select" formControlName="officeId" data-extension-safe>
                    <option selected value="">Select Office</option>
                    <option *ngFor="let office of offices$ | async" [value]="office.id">
                      {{ office.officeName | capitalize }}
                    </option>
                    <!-- <option>Guillory</option>
                    <option>Jami</option> -->
                  </select>
                  <div
                    *ngIf="
                      form.get('companyInfoForm')?.get('officeId')?.invalid &&
                      form.get('companyInfoForm')?.get('officeId')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('companyInfoForm.officeId') }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label" for="departmentId"
                    >Department <span class="text-danger">*</span></label
                  >
                  <select
                    data-extension-safe
                    class="form-select"
                    formControlName="departmentId"
                    [(ngModel)]="selectedDepartmentId"
                    (change)="onDepartmentChange(selectedDepartmentId)"
                  >
                    <option value="" selected>Select Department</option>
                    <option *ngFor="let department of departments$ | async" [value]="department.id">
                      {{ department.departmentName | capitalize }}
                    </option>
                    <!-- <option>IT Management</option>
                      <option> Marketing</option> -->
                  </select>
                  <div
                    *ngIf="
                      form.get('companyInfoForm')?.get('departmentId')?.invalid &&
                      form.get('companyInfoForm')?.get('departmentId')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('companyInfoForm.departmentId') }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label" for="designationId"
                    >Designation <span class="text-danger">*</span></label
                  >
                  <select class="form-select" formControlName="designationId" data-extension-safe>
                    <option value="" selected>Select Designation</option>
                    <option
                      *ngFor="let designation of designations$ | async"
                      [value]="designation.id"
                    >
                      {{ designation.designationName | capitalize }}
                    </option>
                    <!-- <option>IT Management</option>
                      <option> Marketing</option> -->
                  </select>
                  <div
                    *ngIf="
                      form.get('companyInfoForm')?.get('designationId')?.invalid &&
                      form.get('companyInfoForm')?.get('designationId')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('companyInfoForm.designationId') }}
                    </span>
                  </div>
                </div>
              </div>

              <!-- <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label" for="empId"
                    >Employee ID<span class="text-danger"> *</span></label
                  >
                  <input class="form-control" type="text" formControlName="empId" />
                  <div
                    *ngIf="
                      form.get('companyInfoForm')?.get('empId')?.invalid &&
                      form.get('companyInfoForm')?.get('empId')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('companyInfoForm.empId') }}
                    </span>
                  </div>
                </div>
              </div> -->

              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label" for="gender"
                    >Gender <span class="text-danger">*</span></label
                  >
                  <select class="form-select" formControlName="gender" data-extension-safe>
                    <option value="">Select Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Transgender">Transgender</option>
                  </select>

                  <div
                    *ngIf="
                      form.get('companyInfoForm')?.get('gender')?.invalid &&
                      form.get('companyInfoForm')?.get('gender')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('companyInfoForm.gender') }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label" for="role"
                    >Employment Type <span class="text-danger">*</span></label
                  >
                  <select class="form-select" formControlName="role" data-extension-safe>
                    <option value="">Select Type</option>
                    <option value="Employee">Employee</option>
                    <option value="Contractor" *appHasPermission="{ contractor: ['view'] }">
                      Contractor
                    </option>
                    <option value="Trainee">Trainee</option>
                  </select>

                  <div
                    *ngIf="
                      form.get('companyInfoForm')?.get('role')?.invalid &&
                      form.get('companyInfoForm')?.get('role')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('companyInfoForm.role') }}
                    </span>
                  </div>
                </div>
              </div>

              <!-- <div class="col-md-3">
                <div class="mb-3">
                  <label class="form-label col-lg-12"
                    >Portal Access?
                    <div class="form-check form-check-inline form-check-md form-switch me-2">
                      <label class="form-check-label mt-0">
                        <input
                          class="form-check-input me-2"
                          type="checkbox"
                          role="switch"
                          formControlName="portalAccess"
                          (change)="togglePortalAccess()"
                        />
                        {{ portalAccess ? 'Yes' : 'No' }}
                      </label>
                    </div>
                  </label>
                </div>
              </div> -->

              <div class="col-md-3">
                <div class="mb-3">
                  <label class="form-label d-block" for="portalAccess">Portal Access?</label>

                  <div class="form-check form-switch d-flex align-items-center mb-0">
                    <input
                      class="form-check-input me-2"
                      type="checkbox"
                      role="switch"
                      formControlName="portalAccess"
                      (change)="togglePortalAccess()"
                    />
                    <label class="form-check-label mb-0" for="portalAccess">
                      {{ portalAccess ? 'Yes' : 'No' }}
                    </label>
                  </div>
                </div>
              </div>

              <div class="col-lg-12 text-end form-wizard-button">
                <!-- <button
                  type="button"
                  (click)="onSubmit()"
                  [disabled]="createloading || !form.get('companyInfoForm')?.valid"
                  class="btn btn-primary wizard-next-btn"
                >
                  <span
                    *ngIf="createloading"
                    class="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  {{ createloading ? 'Saving...' : 'Save' }}
                </button> -->
                <!-- 1 -->
                <button
                  type="button"
                  (click)="onSubmit()"
                  [disabled]="!form.get('companyInfoForm')?.valid || createloading"
                  class="btn btn-primary wizard-next-btn"
                >
                  <span
                    *ngIf="createloading"
                    class="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  {{ createloading ? 'Saving...' : 'Save' }}
                </button>
              </div>
            </div>
          </div>
        </fieldset>
      </form>
    </div>
  </div>
  <!-- </div>
    </div>
  </div> -->
</ng-template>
